export default __webpack_public_path__ + "static/media/Welspun India Limited.72c52d7f.jpg";